import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import {Link} from 'react-router';
import WoffEmbeddedIcon from 'components/WoffEmbeddedIcon';

const PREVIEW_TAB_LIGHT = 'PREVIEW_TAB_LIGHT';
const PREVIEW_TAB_DARK = 'PREVIEW_TAB_DARK';

export default createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    iconSet: ImmutablePropTypes.record,
    icon: ImmutablePropTypes.record,
    workingSetIcon: ImmutablePropTypes.record,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return {
      previewTab: PREVIEW_TAB_LIGHT,
    };
  },

  handleLightPreviewClicked(event) {
    event.preventDefault();

    this.setState({previewTab: PREVIEW_TAB_LIGHT});
  },

  handleDarkPreviewClicked(event) {
    event.preventDefault();

    this.setState({previewTab: PREVIEW_TAB_DARK});
  },

  render() {
    const {kitToken, iconSet, workingSetIcon} = this.props;
    const isLightPreview = (this.state.previewTab === PREVIEW_TAB_LIGHT);
    const isDarkPreview = (this.state.previewTab === PREVIEW_TAB_DARK);

    const custom = workingSetIcon.custom;
    const optimizedFor = workingSetIcon.optimizedFor;

    const lightTabClassName = classnames('nav-item', {active: isLightPreview});
    const darkTabClassName = classnames('nav-item', {active: isDarkPreview});
    const gridClassName = classnames('grid', `grid-${optimizedFor}`);
    const alertClassName = classnames('well p-xs-a-lg text-xs-center', {'bg-body': isLightPreview, 'bg-gray': isDarkPreview});

    let attribution = null;

    if (custom) {
      attribution = (
        <tr className="asset-origin asset-origin-uploaded">
          <th scope="row" className="text-normal"><i className="ficon ficon-uploaded"></i> Uploaded by</th>
          <td className="text-strong asset-origin-author">You</td>
        </tr>
      );
    } else {
      attribution = (
        <tr className="asset-set">
          <th scope="row" className="text-normal">Icon Set</th>
          <td className="text-strong">{iconSet.name} &middot;  v{iconSet.version}</td>
        </tr>
      );
    }

    return (
      <div>
        <ul className="nav nav-tabs-inline m-xs-b-md">
          <li className={lightTabClassName}><a className="nav-link" onClick={this.handleLightPreviewClicked} href="#">Light</a></li>
          <li className={darkTabClassName}><a className="nav-link" onClick={this.handleDarkPreviewClicked} href="#">Dark</a></li>
        </ul>
        <div className={alertClassName}>
          <div className={gridClassName}>
            <WoffEmbeddedIcon woff={workingSetIcon.woff} />
          </div>
        </div>
        <table className="table table-condensed m-xs-t-md text-muted">
          <tbody>
            {attribution}
            <tr className="asset-optimized">
              <th scope="row" className="text-normal">Optimized for</th>
              <td>{workingSetIcon.optimizedFor}</td>
            </tr>
            <tr className="asset-history">
              <th scope="row" className="text-normal">Last Edited</th>
              <td>{workingSetIcon.updatedAt.fromNow()}</td>
            </tr>
            <tr className="asset-use-desktop">
              <th scope="row" className="text-normal">HTML use</th>
              <td className="p-xs-r-0">
                <div className="well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm">
                  <div className="code code-highlight">
                    <span className="nt">&lt;i</span>&nbsp;
                    <span className="na">class=&quot;</span>
                    <span className="s">{workingSetIcon.cssClass}</span>
                    <span className="na">&quot;</span>
                    <span className="nt">&gt;</span>
                    <span className="nt">&lt;/i&gt;</span>
                  </div>
                </div>
                <p className="text-sm m-xs-b-0 text-muted">
                  <Link to={`/kits/${kitToken}/docs`}>More on how to use your kit&apos;s icons</Link>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/IconPreview.js